import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../StuStyles/StudentProfile.css";
import { TiArrowBack } from "react-icons/ti";
import { useNavigate, useLocation } from "react-router-dom";

import ApiService from "../../../nhrc_apis/ApiService";

const { AdminAPI } = ApiService;

const EmpregView = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const membershipId =
    location.state?.membershipId ||
    location.state?.id ||
    null;

  const [data, setData] = useState(null);
  const [member, setMember] = useState({});
  const [details, setDetails] = useState({});
  const [loading, setLoading] = useState(true);

  /* =========================
     FETCH EMPLOYEE DATA
  ========================== */
  useEffect(() => {
    if (membershipId) {
      fetchEmployee();
    } else {
      setLoading(false);
    }
  }, [membershipId]);

  const fetchEmployee = async () => {
    try {
      const res = await AdminAPI.getMemberById(membershipId);

      console.log("FULL API RESPONSE =>", res.data);

      /*
        API FORMAT:
        {
          member: { ... },
          details: { ... }
        }
      */

      const responseData = res.data || {};

      const memberData = responseData.member || {};
      const detailsData = responseData.details || {};

      setMember(memberData);
      setDetails(detailsData);

      setData(responseData);

      console.log("MEMBER DATA =>", memberData);
      console.log("DETAILS DATA =>", detailsData);

    } catch (err) {
      console.error("API ERROR:", err);
      setData(null);
    } finally {
      setLoading(false);
    }
  };

  /* =========================
     IMAGE HANDLER
  ========================== */
  const getImage = (img) => {
    if (!img) {
      return "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
    }

    if (typeof img === "string") {
      return img.startsWith("http")
        ? img
        : `https://nhrc.onrender.com/${img}`;
    }

    return "https://dummyimage.com/150x150/cccccc/000000&text=No+Image";
  };

  /* =========================
     NO MEMBERSHIP ID
  ========================== */
  if (!membershipId) {
    return (
      <div className="container mt-5 text-center">
        <h5>No Employee Data Found</h5>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    );
  }

  /* =========================
     LOADING
  ========================== */
  if (loading) {
    return (
      <div className="container mt-5 text-center">
        <h5>Loading...</h5>
      </div>
    );
  }

  /* =========================
     NO DATA
  ========================== */
  if (!data) {
    return (
      <div className="container mt-5 text-center">
        <h5>No Employee Data Found</h5>

        <button
          className="btn btn-primary mt-3"
          onClick={() => navigate(-1)}
        >
          Go Back
        </button>
      </div>
    );
  }

  return (
    <div className="container student-profile-container mt-5 mb-0">

      {/* ================= HEADER ================= */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="fw-bold mt-3">EMPLOYEE REGISTRATION</h4>
      </div>

      {/* ================= BACK BUTTON ================= */}
      <button
        className="jobback mb-3"
        style={{ width: "90px" }}
        onClick={() => navigate(-1)}
      >
        <TiArrowBack /> Back
      </button>

      {/* ================= PERSONAL DETAILS ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Personal Details
        </h5>

        <div className="row g-3 mt-2">

          {/* PROFILE PIC */}
          <div className="col-md-4">
            <label className="form-label">Profile Pic</label>

            <img
              src={getImage(member.profile_pic)}
              alt="Profile"
              className="profile-pic"
            />
          </div>

          {/* FULL NAME */}
          <div className="col-md-4">
            <label className="form-label">Full Name</label>

            <input
              className="form-control"
              value={member.full_name || ""}
              readOnly
            />
          </div>

          {/* EMAIL */}
          <div className="col-md-4">
            <label className="form-label">Email</label>

            <input
              className="form-control"
              value={member.email || ""}
              readOnly
            />
          </div>

          {/* DATE OF BIRTH */}
          <div className="col-md-4">
            <label className="form-label">Date Of Birth</label>

            <input
              className="form-control"
              value={member.dob || ""}
              readOnly
            />
          </div>

          {/* GENDER */}
          <div className="col-md-4">
            <label className="form-label">Gender</label>

            <input
              className="form-control"
              value={member.gender || ""}
              readOnly
            />
          </div>

          {/* STATE */}
          <div className="col-md-4">
            <label className="form-label">State</label>

            <input
              className="form-control"
              value={member.state || ""}
              readOnly
            />
          </div>

          {/* DISTRICT */}
          <div className="col-md-4">
            <label className="form-label">District</label>

            <input
              className="form-control"
              value={member.district || ""}
              readOnly
            />
          </div>

          {/* PINCODE */}
          <div className="col-md-4">
            <label className="form-label">Pincode</label>

            <input
              className="form-control"
              value={member.pincode || ""}
              readOnly
            />
          </div>

          {/* BLOOD GROUP */}
          <div className="col-md-4">
            <label className="form-label">Blood Group</label>

            <input
              className="form-control"
              value={member.blood_group || ""}
              readOnly
            />
          </div>

          {/* MOBILE */}
          <div className="col-md-4">
            <label className="form-label">Mobile Number</label>

            <input
              className="form-control"
              value={member.mobile || ""}
              readOnly
            />
          </div>

          {/* MEMBERSHIP ID */}
          <div className="col-md-4">
            <label className="form-label">Membership ID</label>

            <input
              className="form-control"
              value={member.membership_id || ""}
              readOnly
            />
          </div>

          {/* STATUS */}
          <div className="col-md-4">
            <label className="form-label">Status</label>

            <input
              className="form-control"
              value={member.status || ""}
              readOnly
            />
          </div>

          {/* ROLE */}
          <div className="col-md-4">
            <label className="form-label">Role</label>

            <input
              className="form-control"
              value={member.role || ""}
              readOnly
            />
          </div>

          {/* CANDIDATE TYPE */}
          <div className="col-md-4">
            <label className="form-label">Candidate Type</label>

            <input
              className="form-control"
              value={member.candidate_type || ""}
              readOnly
            />
          </div>

          {/* WHATSAPP */}
          <div className="col-md-4">
            <label className="form-label">WhatsApp Notification</label>

            <input
              className="form-control"
              value={String(member.whatsapp_notification)}
              readOnly
            />
          </div>

          {/* CREATED AT */}
          <div className="col-md-4">
            <label className="form-label">Created At</label>

            <input
              className="form-control"
              value={member.created_at || ""}
              readOnly
            />
          </div>

          {/* APPROVED AT */}
          <div className="col-md-4">
            <label className="form-label">Approved At</label>

            <input
              className="form-control"
              value={member.approved_at || ""}
              readOnly
            />
          </div>

          {/* REJECTED AT */}
          <div className="col-md-4">
            <label className="form-label">Rejected At</label>

            <input
              className="form-control"
              value={member.rejected_at || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= COMPANY EXPERIENCE - 1 ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Company Experience - 1
        </h5>

        <div className="row g-3 mt-2">

          {/* ORGANIZATION NAME */}
          <div className="col-md-4">
            <label className="form-label">Organization Name</label>

            <input
              className="form-control"
              value={details.organization_name || ""}
              readOnly
            />
          </div>

          {/* DEPARTMENT */}
          <div className="col-md-4">
            <label className="form-label">Department</label>

            <input
              className="form-control"
              value={details.department || ""}
              readOnly
            />
          </div>

          {/* DESIGNATION */}
          <div className="col-md-4">
            <label className="form-label">Designation</label>

            <input
              className="form-control"
              value={details.designation || ""}
              readOnly
            />
          </div>

          {/* INDUSTRY */}
          <div className="col-md-4">
            <label className="form-label">Industry</label>

            <input
              className="form-control"
              value={details.industry || ""}
              readOnly
            />
          </div>

          {/* COMPANY WEBSITE */}
          <div className="col-md-4">
            <label className="form-label">Company Website</label>

            <input
              className="form-control"
              value={details.company_website || ""}
              readOnly
            />
          </div>

          {/* WORKING LOCATION */}
          <div className="col-md-4">
            <label className="form-label">Working Location</label>

            <input
              className="form-control"
              value={details.working_location || ""}
              readOnly
            />
          </div>

          {/* EMPLOYEE ID */}
          <div className="col-md-4">
            <label className="form-label">Employee ID</label>

            <input
              className="form-control"
              value={details.employee_id || ""}
              readOnly
            />
          </div>

          {/* EXPERIENCE */}
          <div className="col-md-4">
            <label className="form-label">Experience</label>

            <input
              className="form-control"
              value={details.experience || ""}
              readOnly
            />
          </div>

          {/* OFFICIAL EMAIL */}
          <div className="col-md-4">
            <label className="form-label">Official Email</label>

            <input
              className="form-control"
              value={details.official_email || ""}
              readOnly
            />
          </div>

          {/* COMPANY STRENGTH */}
          <div className="col-md-4">
            <label className="form-label">Company Strength</label>

            <input
              className="form-control"
              value={details.company_strength || ""}
              readOnly
            />
          </div>

          {/* ID CARD FRONT */}
          <div className="col-md-4">
            <label className="form-label">ID Card Front</label>

            <img
              src={getImage(details.id_card_front)}
              alt="ID Front"
              className="id-proof-img"
            />
          </div>

          {/* ID CARD BACK */}
          <div className="col-md-4">
            <label className="form-label">ID Card Back</label>

            <img
              src={getImage(details.id_card_back)}
              alt="ID Back"
              className="id-proof-img"
            />
          </div>

          {/* REFERRAL ID */}
          <div className="col-md-4">
            <label className="form-label">Referral ID</label>

            <input
              className="form-control"
              value={details.referral_id || ""}
              readOnly
            />
          </div>

        </div>
      </div>

      {/* ================= COMPANY EXPERIENCE - 2 ================= */}
      <div className="card p-3 mb-4">

        <h5 className="section-title text-center">
          Company Experience - 2
        </h5>

        <div className="row g-3 mt-2">

          {Array.from({ length: 12 }).map((_, index) => (
            <div className="col-md-4" key={index}>
              <input className="form-control" readOnly />
            </div>
          ))}

        </div>

        <div className="text-end mt-3">
          <button className="btn btn-primary">
            Add Another Company Details
          </button>
        </div>
      </div>

      {/* ================= DEBUG RESPONSE ================= */}
      <div className="card p-3 mb-4">

        <h5 className="mb-3">
          Debug API Response
        </h5>

        <pre style={{ fontSize: "12px", overflow: "auto" }}>
          {JSON.stringify(data, null, 2)}
        </pre>

      </div>

    </div>
  );
};

export default EmpregView;